module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/ACTUARIAL SCIENCE-91aec5028409c72ce969866fc7fbb00e.png";